/* eslint-disable */
import CardTAG from '../CardTAG'
import { IQuestionComponent } from './types'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import reportsSelectors from '../../store/reports/reportsSelectors'
import { Box, MenuItem, Select, SelectChangeEvent, Typography, TextareaAutosize } from '@mui/material'
import FormLayout from '../forms/FormLayout'
import { ReactComponent as ArrowIcon } from '../../assets/images/arrowIcon.svg'
import { AppDispatch } from '../../store'
import { findItemByUuid, updateAnswerOption, updateAnswerText } from '../../store/reports/reportsSlice'
import authSelectors from '../../store/auth/authSelectors'
import { selectStyle, textAreaStyle } from '../../constants/styleConstants'
import colors from '../../constants/colors'

const placeholder = 'Answer Here'


const MultipleSelectGroupQuestionComponent: React.FC<IQuestionComponent> = ({
  questionObj,
  question,
  questionUUID,
  questionId,
  questionOptions,
  control,
  fieldName,
  unregister,
  setValue,
  setAnswersFiles,
  answers = [],
  parent,
  previewOnly = false,
}) => {
  const getAnswer = (questionUUID: any) => {
    if (answers && answers?.length > 0) {
      return findItemByUuid(answers, questionUUID)
    }
    return useSelector(reportsSelectors.answersToCaseTypeQuestion(questionUUID))
  }
  const answer = getAnswer(questionUUID)
  const userEditAccess = useSelector(authSelectors.userReportEditAccess)
  const dispatch = useDispatch<AppDispatch>()

  const renderSelectOptions = (options: any) => {
    
    return options.map((selectOption: { text: string; id: number }, index: any) => {
      return (
        <MenuItem value={selectOption.id} key={selectOption.id}>
          <Typography variant='bodyBold'>{selectOption.text}</Typography>
        </MenuItem>
      )
    })
  }
  const onChangeHandler = (uuid: string, event: SelectChangeEvent) => {
    // console.log(uuid, event.target.value)
    dispatch(
      updateAnswerOption({
        answerUUID: uuid,
        answerText: [event.target.value as unknown as number],
        parentUUID: answer?.uuid
      }),
    )
  }

  const onChangeTextHandler = (uuid: string, event: { target: { value: string } }) => {

    dispatch(
      updateAnswerText({
        answerUUID: uuid,
        answerText: event?.target?.value,
        parentUUID: answer?.uuid,
        questionId
      }),
    )
  }

  const getValue = (options: any, answer: any) => {
    const option = options?.find((opt: any) => opt.id === answer?.options[0])
    return `${option?.id ?? ''}`
  }

  const resolveDisabledButton = () => {
    return previewOnly || !userEditAccess
  }

  const resolveSelectedValueRender = (options: any, answer: any) => {
    const option = options?.find((option: any) => option.id === answer?.options[0])
    if (option) {
      return option.text && option?.text !== ''
        ? undefined
        : () => (
            <Typography variant='h4' color={colors.TAG_TEXT_GRAY}>
              {placeholder}
            </Typography>
          )
    }
    return () => (
      <Typography variant='h4' color={colors.TAG_TEXT_GRAY}>
        {placeholder}
      </Typography>
    )
  }

  return (
    <>
      <div id={`${questionId}`}>
        <CardTAG
          questionCard={true}
          color={`${previewOnly ? 'tagBoxArchive' : 'tagBoxSuccess'}`}
          title={
            <Box sx={{ wordWrap: 'break-word', whiteSpace: 'unset', textOverflow: 'unset' }}>
              <Typography
                variant='h4'
                sx={{
                  wordWrap: 'break-word',
                  overflow: 'hidden',
                }}
              >
                {question}
              </Typography>
            </Box>
          }
          
        >
          <FormLayout>
            {/* {questionObj?.subquestions.map((subquestion: any) => {
              const answer = getAnswer(subquestion.uuid)
              
              return(
                <>
                 <Typography variant='bodyBold' color={colors.TAG_BLUE}>
                  {subquestion?.text_third || subquestion?.text}
                 </Typography>
                  {subquestion.variant.id == 2 ? <TextareaAutosize
                    onChange={e => onChangeTextHandler(subquestion.uuid, e)}
                    value={answer?.answer?.text}
                    style={textAreaStyle}
                    minRows={5}
                    placeholder={'Description'}
                    disabled={resolveDisabledButton()}
                /> :
                <Select
                  key={subquestion.uuid}
                  onChange={e => onChangeHandler(subquestion.uuid, e)}
                  IconComponent={ArrowIcon}
                  renderValue={resolveSelectedValueRender(subquestion.options, answer)}
                  displayEmpty
                  value={getValue(subquestion.options, answer)}
                  sx={[selectStyle]}
                  disabled={resolveDisabledButton()}
                >
                  {renderSelectOptions(subquestion.options)}
                </Select>}
                </>
              )
            })} */}
            {questionObj?.subquestions.map((subquestion: any) => {
            const answer = getAnswer(subquestion.uuid)

            return (
              <React.Fragment key={subquestion.uuid}>
                <Typography variant='bodyBold' color={colors.TAG_BLUE}>
                  {subquestion?.text_third || subquestion?.text}
                </Typography>

                {subquestion.variant.id == 2 ? (
                  <TextareaAutosize
                    onChange={e => onChangeTextHandler(subquestion.uuid, e)}
                    value={answer?.answer?.text}
                    style={textAreaStyle}
                    minRows={5}
                    placeholder='Description'
                    disabled={resolveDisabledButton()}
                  />
                ) : (
                  <Select
                    onChange={e => onChangeHandler(subquestion.uuid, e)}
                    IconComponent={ArrowIcon}
                    renderValue={resolveSelectedValueRender(subquestion.options, answer)}
                    displayEmpty
                    value={getValue(subquestion.options, answer)}
                    sx={[selectStyle]}
                    disabled={resolveDisabledButton()}
                  >
                    {renderSelectOptions(subquestion.options)}
                  </Select>
                )}
              </React.Fragment>
            )
          })}
          </FormLayout>
        </CardTAG>
      </div>
    </>
  )
}

export default MultipleSelectGroupQuestionComponent
